import React from "react";
import { createUseStyles } from "react-jss";
import Row from "reactstrap/lib/Row";

const useStyles = createUseStyles((theme) => ({
	messageWarning: {
		alignItems: "center",
		marginBottom: "50px",
		color: theme.palette.colors.purplishBlue,
		fontSize: "14px",
		fontFamily: theme.fonts.medium,
	},
}));

const OfferBlock = (props) => {
	let { text } = props;
	const classes = useStyles();

	return (
		<Row className={classes.messageWarning}>
			<span>{text.offer_info}</span>
		</Row>
	);
};

export default OfferBlock;
